/* eslint-disable quotes */

import React, { PureComponent } from 'react';
import Slider from 'react-slick';

import CircleArrowButton from 'apps/ask/components/CircleArrowButton';
import TestimonialBox from './TestimonialBox';
import { breakpoints } from 'shared/Responsive';

import Adam from 'images/ask/about/adam.jpg';
import Sandy from 'images/ask/about/sandy.jpg';
import Brittany from 'images/ask/about/brittany.jpg';
//import Nikole from 'images/ask/about/nikole.jpg';
import Julia from 'images/ask/about/julia.jpg';
import Brenda from 'images/ask/about/brenda.jpg';
import Jake from 'images/ask/about/jake.jpg';
import Charles from 'images/ask/about/charles.jpg';
import Hunter from 'images/ask/about/hunter.jpg';
import Shay from 'images/ask/about/shay.jpg';

const testimonials = [
  {
    quote: `"I am consistently impressed with how Triage is able to identify so many and such different appearing lesions on the skin. A great tool!"`,
    avatar: Adam,
    author: 'Dr. Adam Mamelak, MD',
    authorInfo: 'Sanova Dermatology'
  },
  {
    quote: `"I have been involved with the Triage team from the beginning. Having an interest in AI and medicine, I knew an application that could help patients triage their rashes or spots is the future. With a shortage of dermatologists in Canada, Triage will help not only patients but dermatologists as well."`,
    avatar: Sandy,
    author: 'Dr. Sandy Skotnicki, MD',
    authorInfo: 'Bay Dermatology'
  },
  {
    quote: `"As a pharmacist, this is great information to have for my patients as I can not diagnose! A tool like this can go a long way, awesome!"`,
    avatar: Brittany,
    author: 'Brittany T.',
    authorInfo: 'Triage user'
  },
  /*{
    quote: `"Triage is great for figuring out if I need to go to the doctor or if can just treat my symptoms at home."`,
    avatar: Nikole,
    author: 'Nikole B.',
    authorInfo: 'Triage user'
  },*/
  {
    quote: `"I tell all my friends, it’s so easy to use and I love how fast I get reliable answers."`,
    avatar: Julia,
    author: 'Julia W.',
    authorInfo: 'Triage user'
  },
  {
    quote: `"I am blown away with Triage’s technology. Absolutely amazing."`,
    avatar: Brenda,
    author: 'Brenda R.',
    authorInfo: 'Triage user'
  },
  {
    quote: `"Searching for my symptoms online is so overwhelming, Triage saves me time by narrowing down my search."`,
    avatar: Jake,
    author: 'Jake M.',
    authorInfo: 'Triage user'
  },
  {
    quote: `"It’s great for travelling when I don’t have access to my normal healthcare… and someone in the family always seems to get sick!"`,
    avatar: Charles,
    author: 'Charles R.',
    authorInfo: 'Triage user'
  },
  {
    quote: `"From moles to rashes, Triage is my go-to for everything on my skin."`,
    avatar: Hunter,
    author: 'Hunter H.',
    authorInfo: 'Triage user'
  },
  {
    quote: `"Kind of like a new and improved WebMD, but better!"`,
    avatar: Shay,
    author: 'Shay E.',
    authorInfo: 'Triage user'
  }
];

class Testimonials extends PureComponent {
  handlePrevClick = () => {
    this.slider.slickPrev();
  }

  handleNextClick = () => {
    this.slider.slickNext();
  }

  render () {
    const settings = {
      speed: 1000,
      infinite: false,
      arrows: false,
      slidesToShow: 2,
      responsive: [
        {
          breakpoint: breakpoints.tablet,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    return (
      <section className="testimonials">
        <div className="container">
          <div className="testimonials__header">
            <h3>Hear from our customers and partners</h3>
            <div className="testimonials__buttons">
              <CircleArrowButton direction="left" onClick={this.handlePrevClick} />
              <CircleArrowButton direction="right" onClick={this.handleNextClick} />
            </div>
          </div>

          <div className="testimonials__content">
            <Slider ref={s => this.slider = s} {...settings}>
              {
                testimonials.map((t, idx) => <TestimonialBox key={idx} {...t} />)
              }
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

export default Testimonials;
